import ElectricVehicleInfo from './ElectricVehicleInfo';

export default ElectricVehicleInfo;
